export interface Deletable {
  deleted?: boolean
}
